import { Namespace } from "rdflib";
export const vcard = Namespace("http://www.w3.org/2006/vcard/ns#");
export const dc = Namespace("http://purl.org/dc/elements/1.1/");
//# sourceMappingURL=namespaces.js.map